<template>
    <div class="unselectable" style="padding: 0; display: flex; flex-direction: column; align-items: center; gap: 0px; width: 100%">
        <Bar v-for="bar in localResult" :key="bar" :value="bar.probability">
            {{bar.className}}
        </Bar>
    </div>
</template>

<script>
import Bar from '@/tm/Bar'

export default {
    name: 'ModelResult',
    props: {
        result: {
            default: []
        }
    },
    data(){
        return {
            localResult: []
        }
    },
    components: {
        Bar,
    },
    watch: {
        result(newValue, oldValue){
            requestAnimationFrame(() => {
                if (!this.localResult) {
                    this.localResult = newValue
                    return
                }
                if (newValue.length != oldValue.length) {
                    this.localResult = newValue
                    return
                }
                for(let i = 0; i < newValue.length; i++) {
                    if (oldValue[i].className != newValue[i].className) {
                        this.localResult = newValue
                        return
                    }
                }
                for(let i = 0; i < newValue.length; i++) {
                    this.localResult[i].probability = newValue[i].probability
                }
            })
        }
    },
    mounted(){
        this.localResult = this.result
    }
}
</script>